import { ThemeProvider, useMediaQuery } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme } from '@mui/material/styles';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AppRoutes from './AppRoutes.js';
import { Loading } from './components/index.js';
import { getThemeOptions } from './global-styles/globalTheme.js';
import { useCrossTabCommunication, useInitialSetup } from './hooks/index.js';
import { setColorMode } from './redux/reducers/common.js';
import { getColorMode } from './redux/selectors.js';


function App() {
  const { isLoading } = useInitialSetup();
  useCrossTabCommunication();

  const colorMode = useSelector(getColorMode);
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const dispatch = useDispatch();
  useEffect(() => {
    if (prefersDarkMode && colorMode !== 'dark') {
      dispatch(setColorMode('dark'));
    }
  }, []);

  const theme = useMemo(() => createTheme(getThemeOptions(colorMode)), [colorMode]);


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isLoading
        ? <Loading backdrop />
        : <AppRoutes />
      }
    </ThemeProvider>
  );
}

export default App;
